import { useFormContext } from 'react-hook-form';

import { withTooltip } from '@crossnokaye/ux-common';
import { Button } from '@crossnokaye/ux-common/ckds';

import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';

const ButtonWithTooltip = withTooltip(Button);

export const AddEventButton = (): React.ReactNode => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });
  const form = useFormContext();

  const handleAddEvent = () => {
    const data = form.getValues();
    const currentEvents = data.defrostSchedule ?? [];
    // Zero out seconds/ms — defrost schedules only have minute-level precision,
    // and leftover seconds from new Date() would be persisted to the server.
    const now = new Date();
    now.setSeconds(0, 0);
    form.setValue(
      'defrostSchedule',
      [...currentEvents, { startTime: now, endDate: undefined, eventDays: [] }],
      {
        shouldDirty: true,
        shouldValidate: true,
      }
    );
  };

  return (
    <ButtonWithTooltip
      delayDuration={0}
      disabled={disabledByPermissions}
      onClick={handleAddEvent}
      size="sm"
      tooltipContent={tooltipText}
    >
      Add Event
    </ButtonWithTooltip>
  );
};
